import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';

export const IntroOfferTooltip = (props) => {
  if (!props?.data || props?.data?.id === 'load-more' || props?.data?.isIntroOffered) {
    return null;
  }

  return (
    <Flex
      tx="popover"
      variant="tooltip.container"
      className="custom-tooltip"
      sx={{
        minWidth: '300px',
        fontSize: '14px',
        lineHeight: '1.4',
        color: '#fff',
        flexDirection: 'column',
        gap: '8px',
        fontFamily: 'silka',
      }}
    >
      <Text>Know someone who can help? Click to offer an intro.</Text>
      <Text>
        We’ll notify {props?.data?.sharedList?.pointOfContact?.fullName}, and they’ll send you a forwardable email if
        they want to proceed.
      </Text>
      <Text>Nothing will be sent to the contact you&apos;re offering an intro to.</Text>
    </Flex>
  );
};

IntroOfferTooltip.propTypes = {
  data: PropTypes.object.isRequired,
};
